export default {
  title: 'Factures de commande',
  list: {
    empty_list: {
      title: "Aucune facture de commande pour l'instant.",
    },
    fields: {
      id: 'Id',
      total: 'Total',
      date: 'Date',
    },
  },
  export_modal: {
    title: 'Filtrer',
    start_date: {
      title: 'Date de début',
      placeholder: 'date',
    },
    end_date: {
      title: 'Date de fin',
      placeholder: 'date',
    },
    button: {
      title1: 'Appliquer',
      title2: 'Fermer',
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
